const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:80';

/**
 * Config file with some variables.
 */
const config = {
  backend: {
    endpoint: API_URL,
  },
};

// production values
const NODE_ENV = process.env.REACT_APP_NODE_ENV;
if (NODE_ENV === 'cloud-production') {
    config.backend.endpoint = 'https://d2uam90o9m59kh.cloudfront.net';
} else if (NODE_ENV === 'cloud-test') {
    config.backend.endpoint = 'http://o2-staging-backend-homecare.salvus.me';
}

export default config;
